export const VALUE_FILTER = {
     certificationLevel: 'certificationLevel',
     trainedStatus: 'trainedStatus',
     trainedPercentage: 'trainedPercentage',
     certifiedStatus: 'certifiedStatus',
     certifiedPercentage: 'certifiedPercentage',
     onTheLocator: 'onTheLocator',
     hasAccess: 'hasAccess',
     elementStatus: 'elementStatus',
     professionalFieldsStatus: 'professionalFieldsStatus',
};

const LABEL_FILTER = {
     certificationLevel: 'Certification Level',
     trainedStatus: 'CAMS Trained Status',
     trainedPercentage: 'Trained Percentage',
     certifiedStatus: 'CAMS Certified  Status',
     certifiedPercentage: 'Certified  Percentage',
     onTheLocator: 'On the Locator',
     hasAccess: 'Has Access',
     professionalFieldsStatus: 'Professional Fields Status',
     elementStatus: 'Element Status',
};

export const SCOPE_OPTIONS = [
     {
          value: VALUE_FILTER.onTheLocator,
          label: LABEL_FILTER.onTheLocator,
     },
     {
          value: VALUE_FILTER.hasAccess,
          label: LABEL_FILTER.hasAccess,
     },
     {
          value: VALUE_FILTER.elementStatus,
          label: LABEL_FILTER.elementStatus,
     },
     {
          value: VALUE_FILTER.professionalFieldsStatus,
          label: LABEL_FILTER.professionalFieldsStatus,
     },
];

export const TRAINED_OPTIONS = [
     {
          value: VALUE_FILTER.trainedStatus,
          label: LABEL_FILTER.trainedStatus,
     },
     {
          value: VALUE_FILTER.trainedPercentage,
          label: LABEL_FILTER.trainedPercentage,
     },
];

export const CERTIFIED_OPTIONS = [
     {
          value: VALUE_FILTER.certifiedStatus,
          label: LABEL_FILTER.certifiedStatus,
     },
     {
          value: VALUE_FILTER.certifiedPercentage,
          label: LABEL_FILTER.certifiedPercentage,
     },
];

export const CERTIFICATION_OPTIONS = [
     { value: 'both', label: 'Both' },
     { value: 'trained', label: 'CAMS Trained' },
     { value: 'certificated', label: 'CAMS Certified' },
     // { value: 'notLevel', label: 'Not Level Achieved' },
];

export const STATUS_OPTIONS = [
     {
          value: 'complete',
          label: 'Complete',
     },
     {
          value: 'incomplete',
          label: 'Incomplete',
     },
];

export const YES_NO_NOANSWER_OPTIONS = [
     {
          value: 'yes',
          label: 'Yes',
     },
     {
          value: 'no',
          label: 'No',
     },
     {
          value: 'unknown',
          label: 'No Answer',
     },
];

export const YES_NO_OPTIONS = [
     {
          value: 'yes',
          label: 'Yes',
     },
     {
          value: 'no',
          label: 'No',
     },
];

export const COMPARISON_OPTIONS = [
     {
          value: 'gt',
          label: 'Greater than',
     },
     {
          value: 'lt',
          label: 'Less than',
     },
     {
          value: 'eq',
          label: 'Equal',
     },
];
